<template>
  <div :class="$style.pageContainer" v-if="isvisible">
    <form :class="$style.addSquawkOverlayPopup" ref="squawkForm">
      <b :class="$style.aircraftDiscrepancySquawk"
        >Aircraft Discrepancy Squawk</b
      >
      <div :class="$style.thisFormIs">
        This form is to be filled out anytime a discrepancy is noted.
      </div>
      <!-- {{ modalData.squawk.actionTaken }} -->
      <!-- {{ formData }} -->
      <div :class="$style.frameParent">
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Tail Number
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Tail Number..."
              required
              v-model="formData.tailNumber"
              :disabled="true"
              id="tailNumber"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Pilot Name
          </div>
          <div class="col-sm-9 d-flex">
            <input
              type="text"
              placeholder="Pilot Name..."
              required
              v-model="formData.pilotName"
              class="flex-fill mr-2"
              :disabled="true"
              id="pilotName"
            />
            <input
              type="date"
              placeholder="Pick a Date..."
              required
              v-model="formData.creationDate"
              :disabled="true"
              id="creationDate"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Description
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Description of issue..."
              required
              v-model="formData.description"
              :disabled="isView || isEdit"
              id="description"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Admin Name
          </div>
          <div class="col-sm-9 d-flex">
            <input
              type="text"
              placeholder="Name..."
              required
              v-model="formData.adminName"
              class="flex-fill mr-2"
              :disabled="true"
              id="adminName"
            />
            <input
              type="date"
              placeholder="Pick a Date..."
              required
              v-model="formData.approvalDate"
              :disabled="true"
              id="approvalDate"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Priority</div>
          <div class="col-sm-9">
            <HiloSelect
              :options="[
                { id: 1, name: '1' },
                { id: 2, name: '2' },
                { id: 3, name: '3' },
                { id: 4, name: '4' },
                { id: 5, name: '5' },
              ]"
              :theme="'grey'"
              v-model="formData.priority"
              placeholder="1-5..."
              :customStyle="{
                height: '48px',
                backgroundColor: '#f5f5f5',
                border: 'none',
                padding: '10px',
              }"
              :disabled="isView || validateRole('Admin')"
              id="priority"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Admin Notes
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Enter notes..."
              required
              v-model="formData.adminNotes"
              :disabled="isView || validateRole('Admin')"
              class="form-input"
              id="adminNotes"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Status</div>
          <div class="col-sm-9">
            <HiloSelect
              :options="status"
              :theme="'grey'"
              v-model="formData.squawkStatusId"
              placeholder="Select status..."
              :customStyle="{
                height: '48px',
                backgroundColor: '#f5f5f5',
                border: 'none',
                padding: '10px',
              }"
              :disabled="isView || validateRole('Admin', 'Maintenance')"
              id="squawkStatusId"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Mechanic</div>
          <div class="col-sm-9 d-flex">
            <input
              type="text"
              placeholder="Name..."
              required
              v-model="formData.mechanicName"
              class="flex-fill mr-2"
              :disabled="true"
              id="mechanicName"
            />
            <input
              type="date"
              required
              v-model="formData.actionTakenDate"
              class="flex-fill"
              :disabled="true"
              id="actionTakenDate"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Action Taken
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Action taken..."
              required
              v-model="formData.actionTaken"
              :disabled="isView || validateRole('Maintenance')"
              id="actionTaken"
            />
          </div>
        </div>
      </div>
      <div :class="$style.saveWrapper" @click="submitForm" v-if="!isView">
        <b :class="$style.save">Save</b>
      </div>
      <img
        :class="$style.vectorIcon5"
        alt=""
        src="/static/img/grey-x.svg"
        @click="onXClick"
      />
    </form>

    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import dayjs from "dayjs";
import HiloSelect from "../../../../components/HiloComponents/HiloSelect.vue";
import SquawksAPIService from "../../../../servicehandlers/SquawksAPIService";
import ToastNotifier from "@/components/ToastNotifier.vue";
const squawksAPIService = new SquawksAPIService();

export default {
  name: "AddSquawk",
  components: { HiloSelect, ToastNotifier },
  props: {
    status: {
      type: Array,
      required: true,
      default: () => [],
    },
    mode: {
      type: String,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Object,
      default: () => ({}),
    },
    isvisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isvisible(val) {
      if (val) {
        this.formData = {
          tailNumber: this.modalData?.aircraft?.tailNumber,
          pilotName: this.$global.getFullName(this.user),
          creationUserId: this.user.id,
          creationDate: dayjs().format("YYYY-MM-DD"),
          aircraftId: this.modalData?.aircraft?.id,
        };

        if (this.isView || this.isEdit) {
          const squawk = this.modalData.squawk;

          this.formData.pilotName = this.$global.getFullName(
            squawk.creationUser,
          );
          this.formData.creationUserId = squawk.creationUserId;
          this.formData.creationDate = dayjs(squawk.creationDate).format(
            "YYYY-MM-DD",
          );
          this.formData.description = squawk.description;
          this.formData.priority = squawk.priority;
          this.formData.squawkStatusId = squawk.squawkStatusId;
          this.formData.adminNotes = squawk.adminNotes;
          this.formData.actionTaken = squawk.actionTaken;

          if (squawk.adminUserId) {
            this.formData.adminUserId = squawk.adminUserId;
            this.formData.adminName = this.$global.getFullName(
              squawk.adminUser,
            );
          } else if (this.user.userType.name === "Admin") {
            this.formData.adminUserId = this.user.id;
            this.formData.adminName = this.$global.getFullName(this.user);
          }

          if (this.user.userType.name === "Admin") {
            this.formData.approvalDate = squawk.approvalDate
              ? dayjs(squawk.approvalDate).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD");
          } else {
            this.formData.approvalDate = squawk.approvalDate
              ? dayjs(squawk.approvalDate).format("YYYY-MM-DD")
              : "";
          }

          this.formData.mechanicUserId = squawk.mechanicUserId || "";
          this.formData.mechanicName = squawk.mechanicUserId
            ? this.$global.getFullName(squawk.mechanicUser)
            : "";
          this.formData.actionTakenDate = squawk.actionTakenDate
            ? dayjs(squawk.actionTakenDate).format("YYYY-MM-DD")
            : "";

          if (this.user.userType.name === "Maintenance") {
            this.formData.mechanicUserId = this.user.id;
            this.formData.mechanicName = this.$global.getFullName(this.user);
            if (!squawk.actionTakenDate) {
              this.formData.actionTakenDate = dayjs().format("YYYY-MM-DD");
            } else {
              this.formData.actionTakenDate = dayjs(
                squawk.actionTakenDate,
              ).format("YYYY-MM-DD");
            }
          }
        }

        if (
          !this.isView &&
          !this.isEdit &&
          this.user.userType.name === "Admin"
        ) {
          this.formData.adminUserId = this.user.id;
          this.formData.adminName = this.$global.getFullName(this.user);
          this.formData.approvalDate = dayjs().format("YYYY-MM-DD");
        } else if (
          !this.isView &&
          !this.isEdit &&
          this.user.userType.name === "Maintenance"
        ) {
          this.formData.mechanicUserId = this.user.id;
          this.formData.mechanicName = this.$global.getFullName(this.user);
        }
      } else {
        this.formData = {};
      }

      this.$forceUpdate();
    },
  },
  computed: {
    user() {
      return this.$store.getUser;
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  methods: {
    validateRole(...role) {
      return !role.includes(this.$store.getUser.userType.name);
    },
    onXClick() {
      this.$emit("close");
    },
    async submitForm() {
      try {
        const form = this.$refs.squawkForm;
        const inputs = form.querySelectorAll("input, select");
        let requiredFields = [];
        inputs.forEach((input) => {
          if (!input.disabled) {
            requiredFields.push(input.id);
          }
        });

        const filteredFields = requiredFields.filter((x) => !this.formData[x]);
        const validations =
          this.$global.createMultipleValidations(filteredFields);

        if (validations.length) {
          this.$refs.toast.showError(validations);
          return;
        }

        if (this.user.userType.name === "Admin") {
          this.formData.approvalDate = dayjs(
            this.formData.approvalDate,
          ).toISOString();
        } else if (this.user.userType.name === "Maintenance") {
          this.formData.actionTakenDate = dayjs(
            this.formData.actionTakenDate,
          ).toISOString();
        }

        if (this.isEdit) {
          await squawksAPIService.update(
            this.modalData.squawk.id,
            this.formData,
          );
        } else {
          await squawksAPIService.create(this.formData);
        }
        this.$emit("save");
      } catch (error) {}
    },
  },
};
</script>
<style module scoped>
.pageContainer {
  max-width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
.addSquawkOverlayPopup {
  width: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin: auto;
  max-height: 90vh;
  height: 90vh;
  overflow: auto;
}
.aircraftDiscrepancySquawk {
  font-size: 36px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  margin-bottom: 15px;
}
.thisFormIs {
  font-size: 15px;
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 15px;
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
}
.save {
  position: relative;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.saveWrapper {
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
}
.vectorIcon5 {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 47px;
  right: 51px;
  height: 12px;
  cursor: pointer;
}
input[type="date"] {
  height: 47px;
}
</style>
